export default __webpack_public_path__ + "static/media/back.16fc6551.svg";